// volto-wantai — tenant addon for wantai.ljusa-tider.se, Wantai Biopharm's
// EU market-access + regulatory-content collaboration site (DR-2026-258).
//
// Deliberately minimal at v0.1.0: two supported languages (en canonical +
// zh-CN for Wantai HQ review) over the converged VLT-8 baseline. The four
// market languages (fr/es/it/pt) are added when compliance content is
// localized. Private-by-default (content stays in the private workflow state),
// so the login-state indicator is load-bearing: the sole slot override is the
// token-truth UserTools over VLT's Anontools (BUG-2026-217 / BUG-2026-211 /
// CR-2026-009 pattern — VLT's Anontools renders from nick's non-existent
// @actions endpoint and goes stale on all-private tenants).

import { applyTenantBaseline } from 'volto-tenant-baseline/applyTenantBaseline';
import DeckRoute from './components/Deck/DeckRoute';

const applyConfig = (config) => {
  config.settings.supportedLanguages = ['en', 'zh-CN'];
  config.settings.defaultLanguage = 'en';
  config.settings.isMultilingual = true;

  // -- Wantai European selling deck (DR-2026-261) --
  // A full-screen, keyboard-navigable slideshow (REF-WANTAI-001 §15) at
  // /en/deck. addonRoutes have higher priority than the content catch-all
  // (Volto routes.js), so this resolves before View. The matching
  // nonContentRoutes entry stops Volto fetching /en/deck as CMS content
  // (getBaseUrl strips the suffix). DeckRoute wraps the deck in RequireLogin
  // so the tenant's private-by-default posture (DR-2026-258) holds: anon →
  // /login, authenticated → the deck.
  // One route per languageroot; DeckRoute reads the languageroot from the path
  // and Deck picks the matching slide set (deckData.js). (DR-2026-264 zh-CN.)
  config.addonRoutes = [
    ...(config.addonRoutes || []),
    { path: '/en/deck', component: DeckRoute },
    { path: '/zh-cn/deck', component: DeckRoute },
  ];
  config.settings.nonContentRoutes = [
    ...(config.settings.nonContentRoutes || []),
    '/en/deck',
    '/zh-cn/deck',
  ];

  // -- Fleet baseline (DR-2026-272 / CR-2026-077) --
  // UserTools slot registration (token-truth over VLT's Anontools) +
  // GuidesLink + tenantBaseline settings — all versioned once in
  // volto-tenant-baseline. Must be called HERE (outermost addon, runs after
  // VLT) so the slot registration wins; the addon's LanguageSelector shadow
  // and 880px token apply via addons[] membership. tenantKey makes the
  // Guides entry carry ?from=wantai so the commons-side ReturnLink can
  // offer the way back (DR-2026-272 return-navigation wave).
  config = applyTenantBaseline(config, { tenantKey: 'wantai' });

  return config;
};

export default applyConfig;
